import { ModalButton, ModalType } from '../../../components/modals/modalAlert/types';

interface ModalsVisibility {
	[name: string]: boolean;
}

export interface ModalState {
	showModal: boolean;
	modal?: Modal;
	modalsVisibility?: ModalsVisibility;
}

export interface Modal {
	type: ModalType;
	title?: string;
	textMessage?: string;
	textMessageIsHtml?: boolean;
	okButton?: ModalButton;
	customButtons?: ModalButton[];
	children?: React.ReactNode;
}

export enum ModalActionTypes {
	OPEN = '@@modal/OPEN',
	CLOSE = '@@modal/CLOSE',
	SHOW = '@@modal/SHOW',
	HIDE = '@@modal/HIDE',
}
